import script from "./EventHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./EventHistory.vue?vue&type=script&setup=true&lang=js"

import "./EventHistory.vue?vue&type=style&index=0&id=685002cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-685002cc"]])

export default __exports__